module.exports = {"130303001":"南关街道","130303002":"古城街道","130303003":"西关街道","130303004":"路南街道","130303100":"第一关镇","130303101":"石河镇","130303102":"孟姜镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130303.json
// module id = 186
// module chunks = 0